import type { I18nName } from './static';

// Static FAQ content (4 locales). Mirrors the app's faq_data.dart — kept here
// rather than i18n keys because each entry is a paired Q/A block.
export const FAQ: { q: I18nName; a: I18nName }[] = [
  {
    q: {
      en: 'How does scoring work?',
      de: 'Wie funktioniert die Punktevergabe?',
      fr: 'Comment fonctionne le score ?',
      it: 'Come funziona il punteggio?',
    },
    a: {
      en: 'Predict the exact score of each match. You earn points for the right outcome (1/X/2), the exact goals, the goal difference, and a bonus for a perfect score. A Beer Boost doubles a match’s points.',
      de: 'Tippe das exakte Resultat jedes Spiels. Punkte gibt es für den richtigen Ausgang (1/X/2), die exakten Tore, die Tordifferenz und einen Bonus für das perfekte Resultat. Ein Beer Boost verdoppelt die Punkte eines Spiels.',
      fr: 'Pronostiquez le score exact de chaque match. Vous gagnez des points pour le bon résultat (1/X/2), les buts exacts, la différence de buts et un bonus pour un score parfait. Un Beer Boost double les points d’un match.',
      it: 'Pronostica il risultato esatto di ogni partita. Guadagni punti per l’esito corretto (1/X/2), i gol esatti, la differenza reti e un bonus per il risultato perfetto. Un Beer Boost raddoppia i punti di una partita.',
    },
  },
  {
    q: {
      en: 'When do predictions lock?',
      de: 'Wann werden Tipps gesperrt?',
      fr: 'Quand les pronostics sont-ils verrouillés ?',
      it: 'Quando si bloccano i pronostici?',
    },
    a: {
      en: 'A match locks at kickoff. You can change your prediction any time before then.',
      de: 'Ein Spiel wird beim Anpfiff gesperrt. Bis dahin kannst du deinen Tipp jederzeit ändern.',
      fr: 'Un match se verrouille au coup d’envoi. Vous pouvez modifier votre pronostic à tout moment avant cela.',
      it: 'Una partita si blocca al fischio d’inizio. Puoi modificare il pronostico fino a quel momento.',
    },
  },
  {
    q: {
      en: 'What is a Beer Boost?',
      de: 'Was ist ein Beer Boost?',
      fr: 'Qu’est-ce qu’un Beer Boost ?',
      it: 'Cos’è un Beer Boost?',
    },
    a: {
      en: 'You get three Beer Boosts per tournament. Activate one on a match to double the points you score there. Spend them wisely.',
      de: 'Du erhältst drei Beer Boosts pro Turnier. Aktiviere einen bei einem Spiel, um die dort erzielten Punkte zu verdoppeln. Setze sie klug ein.',
      fr: 'Vous recevez trois Beer Boosts par tournoi. Activez-en un sur un match pour doubler les points marqués. À utiliser avec sagesse.',
      it: 'Ricevi tre Beer Boost a torneo. Attivane uno su una partita per raddoppiare i punti ottenuti. Usali con saggezza.',
    },
  },
  {
    q: {
      en: 'How do I win prizes?',
      de: 'Wie gewinne ich Preise?',
      fr: 'Comment gagner des prix ?',
      it: 'Come si vincono i premi?',
    },
    a: {
      en: 'Climb the leaderboards and collect vouchers from partner bars and breweries across Switzerland. Check the Prizes tab for what’s on the line.',
      de: 'Klettere in den Ranglisten nach oben und sammle Gutscheine von Partner-Bars und Brauereien in der ganzen Schweiz. Im Tab Preise siehst du, was es zu gewinnen gibt.',
      fr: 'Grimpez dans les classements et collectez des bons auprès des bars et brasseries partenaires de toute la Suisse. Consultez l’onglet Prix pour voir ce qui est en jeu.',
      it: 'Scala le classifiche e colleziona buoni dai bar e birrifici partner di tutta la Svizzera. Controlla la scheda Premi per vedere cosa c’è in palio.',
    },
  },
];
